import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Tabs,
  Tab,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import LegalNoticeTab from './LegalNoticeTab';
import PrivacyPolicyTab from './PrivacyPolicyTab';
import TermsConditionsTab from './TermsConditionsTab';
import { fetchLegalNoticeData, fetchPrivacyPolicyData, fetchTermsConditionsData } from '../../redux/reducers/LegalInformationsReducer';
import SwipeableViews from 'react-swipeable-views';

function LegalInformation() {
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(0);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setTabValue(index);
  };

  const handleFetchData = () => {
    // Dispatch actions to fetch data from Firebase collections
    dispatch(fetchLegalNoticeData());
    dispatch(fetchPrivacyPolicyData());
    dispatch(fetchTermsConditionsData());
  };

  useEffect(() => {
    handleFetchData()
  }, []);

  const tabs = [
    { label: 'Mentions légales' },
    { label: 'Politique de confidentialité' },
    { label: 'Conditions générales d’utilisation' },
  ];

  return (
    <div>
      <SwipeableViews index={tabValue} onChangeIndex={handleChangeIndex}>
        <LegalNoticeTab />
        <PrivacyPolicyTab />
        <TermsConditionsTab />
      </SwipeableViews>
      <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}>
        <AppBar position="static" color="default">
          <Tabs
            value={tabValue}
            onChange={handleChangeTab}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            {tabs.map((tab, index) => (
              <Tab
                key={tab.label}
                label={tab.label}
                style={{
                  backgroundColor: tabValue === index ? '#FC6258' : 'transparent',
                  color: tabValue === index ? 'white' : 'black', 
                }}
              />
            ))}
          </Tabs>
        </AppBar>
      </div>
    </div>
  );
}

export default LegalInformation;
